import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { DateTime } from 'luxon';
import Cookies from 'js-cookie';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

// 은행 목록
const bankOptions = [
  '경남', '광주', '국민', '기업', '농협', '대구', '부산', '산업',
  '새마을금고', '수협', '신한', '신협', '씨티', '우리', '우체국',
  '전북', '제주', '카카오뱅크', '하나', 'KEB하나', 'SC', '토스뱅크', '케이뱅크'
];

const OrderFormModal = ({ onClose, movieInfo,setShowScheduleFilter,totalAmount,movieViewerCount }) => {
  const navigate = useNavigate();
  const [inputMode, setInputMode] = useState('selectedSeat');
  const [amount, setAmount] = useState(totalAmount);
  const [viewerCount, setViewerCount] = useState(movieViewerCount);
  const [selectedSeat, setSelectedSeat] = useState('');
  const [seatText, setSeatText] = useState('');
  const [selectedSeatValue, setSelectedSeatsValue] = useState('');
  const [highlightedSeat, setHighlightedSeat] = useState(''); // 하나의 좌석만 선택할 수 있도록 변경
  //const [highlightedSeats, setHighlightedSeats] = useState([]);
  const couponPrices = JSON.parse(Cookies.get('couponPrices') || '{}');
  const [cinemaBrands, setCinemaBrands] = useState([]);

  // 환불계좌 정보 상태
  const [refundBankInfo, setRefundBankInfo] = useState({
    bank_name: '',
    account_number: '',
    account_holder_name: ''
  });
  const [hasExistingBankInfo, setHasExistingBankInfo] = useState(false);

  // 영화관 브랜드 정보 가져오기
  useEffect(() => {
    fetch('/order/cinema-brands')
      .then(response => response.json())
      .then(data => {
        setCinemaBrands(data);
      })
      .catch(error => {
        console.error('영화관 브랜드 정보 로드 실패:', error);
      });
  }, []);

  // 기등록된 환불계좌 정보 가져오기
  useEffect(() => {
    fetch('/request/getUserInfo')
      .then(response => response.json())
      .then(data => {
        if (data.bank_name && data.account_number) {
          setRefundBankInfo({
            bank_name: data.bank_name || '',
            account_number: data.account_number || '',
            account_holder_name: data.account_holder_name || ''
          });
          setHasExistingBankInfo(true);
        }
      })
      .catch(error => {
        console.error('환불계좌 정보 로드 실패:', error);
      });
  }, []);

  // 환불계좌 정보 변경 핸들러
  const handleRefundBankChange = (e) => {
    const { name, value } = e.target;
    setRefundBankInfo(prev => ({
      ...prev,
      [name]: value
    }));
  };

const openCinemaBookingSite = (cinemaBrand) => {
  console.log('=== 영화관 예매 사이트 열기 시작 ===');
  console.log('요청된 영화관 브랜드:', cinemaBrand);
  console.log('현재 cinemaBrands 배열:', cinemaBrands);
  
  // cinemaBrands 배열에서 해당 브랜드 찾기
  console.log('브랜드 정보 검색 중...');
  const brandInfo = cinemaBrands.find(brand => brand.std_key === cinemaBrand);
  
  console.log('찾은 브랜드 정보:', brandInfo);
  
  if (!brandInfo) {
    console.error('브랜드 정보를 찾을 수 없음:', cinemaBrand);
    alert('영화관 예매 URL 정보가 없습니다.');
    return;
  }
  
  if (!brandInfo.bookingurl) {
    console.error('브랜드는 존재하지만 bookingUrl이 없음:', brandInfo);
    alert('영화관 예매 URL 정보가 없습니다.');
    return;
  }
  
  const bookingUrl = brandInfo.bookingurl;
  const windowName = `${cinemaBrand}_Booking`;
  
  console.log('예매 URL:', bookingUrl);
  console.log('새 창 이름:', windowName);
  console.log('새 창 열기 시도 중...');
  
  try {
    // 실제로 새 창을 여는 코드
    const newWindow = window.open(bookingUrl, windowName, 'width=1200,height=800,toolbar=yes,scrollbars=yes,resizable=yes');
    
    if (newWindow) {
      console.log('새 창 열기 성공');
      console.log('새 창 객체:', newWindow);
    } else {
      console.error('새 창 열기 실패 - 팝업이 차단되었을 수 있음');
      alert('팝업이 차단되었습니다. 브라우저 설정에서 팝업을 허용해주세요.');
    }
  } catch (error) {
    console.error('새 창 열기 중 오류 발생:', error);
    alert('예매 사이트를 여는 중 오류가 발생했습니다.');
  }
  
  console.log('=== 영화관 예매 사이트 열기 완료 ===');
}

  useEffect(() => {
    fetch('/request/session')
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch session data');
        }
        return response.json();
      })
      .then(data => {
        if (data.userName) {
          sessionStorage.setItem('name', data.userName);
        }
        if (data.userId) {
          sessionStorage.setItem('phone_number', data.userId);
        }

        const name = sessionStorage.getItem('name');
        const phone_number = sessionStorage.getItem('phone_number');

        console.log('Name:', name);
        console.log('Phone Number:', phone_number);

        const couponCode = Cookies.get('couponCode');
        console.log('Coupon Code:', couponCode);

        // 관람 인원에 맞는 쿠폰 가격 설정
        const initialAmount = couponPrices[`${viewerCount}인`] || 0;
        setAmount(initialAmount);
      })
      .catch(error => {
        console.error('Error fetching session data:', error);
      });
  }, [viewerCount, couponPrices]);

  // const handleSeatClick = (section) => {
  //   let updatedSeats = highlightedSeats.includes(section)
  //     ? highlightedSeats.filter(seat => seat !== section)
  //     : [...highlightedSeats, section];
  //   setHighlightedSeats(updatedSeats);
  //   setSelectedSeats(updatedSeats.join(', '));
  //   setSelectedSeatsValue(updatedSeats.join(', '));
  // };
  const handleSeatClick = (section) => {
    if (inputMode === 'selectedSeat') {
      setHighlightedSeat(section);
      setSelectedSeat(section);
      setSelectedSeatsValue(section);
      // 블록 선택 시 직접 입력값 초기화
      setSeatText('');
    }
  };

  // 입력 모드 변경 핸들러
  const handleInputModeChange = (mode) => {
    setInputMode(mode);
    if (mode === 'selectedSeat') {
      // 블록 지정 모드로 전환 시 직접 입력값 초기화
      setSeatText('');
    } else if (mode === 'manual') {
      // 직접 입력 모드로 전환 시 블록 선택값 초기화
      setHighlightedSeat('');
      setSelectedSeat('');
      setSelectedSeatsValue('');
    }
  };

  // const handleManualSeatChange = (e) => {
  //   setSelectedSeat(e.target.value);
  //   setHighlightedSeat(e.target.value.split(',').map(seat => seat.trim()));
  // };

  // const handleViewerCountChange = (e) => {
  //   const count = Number(e.target.value);
  //   setViewerCount(count);
  //   const newAmount = couponPrices[`${count}인`] || 0;
  //   setAmount(newAmount);
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 환불계좌 정보 유효성 검사
    if (!refundBankInfo.bank_name || !refundBankInfo.account_number || !refundBankInfo.account_holder_name) {
      alert('환불계좌 정보를 모두 입력해주세요.');
      return;
    }

    // [가드 2026-07-11] 예매권(쿠폰) 연결이 끊긴 상태(쿠키 desync)에서 무쿠폰 0원 주문이 새는 것 방지.
    // 금액이 아니라 쿠폰번호 유무로 판별 — 0원 무료 쿠폰은 couponCode가 있으므로 정상 진행됨.
    const _couponCode = Cookies.get('couponCode');
    if (!_couponCode || _couponCode === 'undefined' || _couponCode === 'null') {
      alert('예매권(쿠폰)이 확인되지 않습니다. 예매권을 다시 적용해 주세요.');
      return;
    }

    const formattedDate = DateTime.fromISO(movieInfo.date).toISODate();

    const formData = {
      movieTitle: movieInfo.movie_title,
      theater: movieInfo.theater,
      cinemaBrand: movieInfo.cinemaBrand,
      date: formattedDate,
      screeningTime: movieInfo.startTime,
      viewerCount,
      seatInfo: transformSeatInfoInString(selectedSeat) + seatText,
      seatInfoValue:selectedSeatValue,
      amount,
      bookingUrlPc: movieInfo.booking_url_pc,
      bookingUrlMobile: movieInfo.booking_url_mobile,
      orderCategory: '씨네트리',
      couponCode: Cookies.get('couponCode'),
      userName: sessionStorage.getItem('name'),
      phoneNumber: sessionStorage.getItem('phone_number'),
      couponPrice: amount,
      paymentMethod: '무통장입금',
      paymentStatus: 'pending',
      orderStatus: '예매대기'
    };

    try {
      // 1. 환불계좌 정보 저장/업데이트
      const bankInfoResponse = await fetch('/request/updateUserBankInfo', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(refundBankInfo),
      });

      if (!bankInfoResponse.ok) {
        const bankError = await bankInfoResponse.json();
        alert('환불계좌 정보 저장 실패: ' + (bankError.message || '다시 시도해주세요.'));
        return;
      }

      // 2. 주문 제출 요청
      const response = await fetch('/order/submit-order', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        const responseData = await response.json();
        // alert(responseData.message + ' 주문번호: ' + responseData.orderId);
        alert(responseData.message);
        // 쿠폰 관련 쿠키 제거
        Cookies.remove('couponCode', { path: '/' });
        Cookies.remove('couponPrices', { path: '/' });
        navigate(`/mypage/order/3`);
        onClose(); // 모달 닫기
      } else {
        // 백엔드에서 보낸 에러 메시지를 받아옵니다.
        const errorData = await response.json();
        // 에러 메시지를 사용자에게 표시합니다.
        alert(':' + errorData.error);
      }
    } catch (error) {
      console.error(':', error);
      alert(':' + error.message);
    }
  };
  const seatMapping = {
    "front center": "앞 중앙 좌석",
    "front left": "앞 좌측 좌석",
    "front right": "앞 우측 좌석",
    "middle center": "중간 중앙 좌석",
    "middle left": "중간 좌측 좌석",
    "middle right": "중간 오른쪽 좌석",
    "back center": "뒤 중앙 좌석",
    "back left": "뒤 좌측 좌석",
    "back right": "뒤 우측 좌석"
  };
  
  function transformSeatInfoInString(text) {
    let transformedText = text;
    
    // seatMapping의 각 키값을 찾아서 해당 값을 변환
    for (const [key, value] of Object.entries(seatMapping)) {
      const regex = new RegExp(key, 'g'); // 문자열에서 여러 개 일치할 수 있으므로 정규식 사용
      transformedText = transformedText.replace(regex, value);
    }
    
    return transformedText;
  }

  return (
    <ModalOverlay>
      <ModalContent>
        <FormTitle>예매 정보 입력</FormTitle>
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label>영화 제목</Label>
            <Input type="text" value={movieInfo.movie_title} disabled />
          </FormGroup>
          <FormGroup>
            <Label>상영 일자</Label>
            <Input type="text" value={DateTime.fromISO(movieInfo.date).toFormat('yyyy-MM-dd')} disabled />
          </FormGroup>
          <FormGroup>
            <Label>상영 시간</Label>
            <Input type="text" value={movieInfo.startTime} disabled />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="screeningRoom">상영관</Label>
            <Input id="screeningRoom" type="text" value={`${movieInfo.theater} ${movieInfo.screening_place}`} disabled />
          </FormGroup>
          {/* <FormGroup>
            <Label htmlFor="amount">금액</Label>
            <Input 
              id="amount" 
              type="number" 
              placeholder="금액 입력" 
              value={amount} 
              onChange={(e) => setAmount(Number(e.target.value))} 
              disabled
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="viewerCount">관람 인원</Label>
            <Select disabled id="viewerCount" value={viewerCount} onChange={handleViewerCountChange}>
              {[1, 2, 3, 4, 5, 6].map((count) => (
                <option key={count} value={count}>{count}명</option>
              ))}
            </Select>
          </FormGroup> */}
          <FormGroup>
    

                    <label style={{fontSize:'9pt', color:'red'}}> 요청좌석 : 블록지정 or 직접입력 중 하나를 선택해주세요</label>
            <ScreenContainer>
              <Screen>스크린</Screen>
              <SeatsGrid>
  <SeatBox
    onClick={() => handleSeatClick('front left')}
    selected={highlightedSeat === 'front left'} // 선택된 좌석과 비교
  >
    {highlightedSeat === 'front left' ? '앞 왼쪽' : ''}
  </SeatBox>
  <SeatBox
    onClick={() => handleSeatClick('front center')}
    selected={highlightedSeat === 'front center'}
  >
    {highlightedSeat === 'front center' ? '앞 중앙' : ''}
  </SeatBox>
  <SeatBox
    onClick={() => handleSeatClick('front right')}
    selected={highlightedSeat === 'front right'}
  >
    {highlightedSeat === 'front right' ? '앞 오른쪽' : ''}
  </SeatBox>
  <SeatBox
    onClick={() => handleSeatClick('middle left')}
    selected={highlightedSeat === 'middle left'}
  >
    {highlightedSeat === 'middle left' ? '중간 왼쪽' : ''}
  </SeatBox>
  <SeatBox
    onClick={() => handleSeatClick('middle center')}
    selected={highlightedSeat === 'middle center'}
  >
    {highlightedSeat === 'middle center' ? '중간 중앙' : ''}
  </SeatBox>
  <SeatBox
    onClick={() => handleSeatClick('middle right')}
    selected={highlightedSeat === 'middle right'}
  >
    {highlightedSeat === 'middle right' ? '중간 오른쪽' : ''}
  </SeatBox>
  <SeatBox
    onClick={() => handleSeatClick('back left')}
    selected={highlightedSeat === 'back left'}
  >
    {highlightedSeat === 'back left' ? '뒤 왼쪽' : ''}
  </SeatBox>
  <SeatBox
    onClick={() => handleSeatClick('back center')}
    selected={highlightedSeat === 'back center'}
  >
    {highlightedSeat === 'back center' ? '뒤 중앙' : ''}
  </SeatBox>
  <SeatBox
    onClick={() => handleSeatClick('back right')}
    selected={highlightedSeat === 'back right'}
  >
    {highlightedSeat === 'back right' ? '뒤 오른쪽' : ''}
  </SeatBox>
  </SeatsGrid>
            </ScreenContainer>
    
        </FormGroup>
  <div style={{ display:'flex',alignItems:'center',flexDirection: 'column'}}>
  <FormGroup>
  <RadioContainer>
    <Label>
      <input
        type="radio"
        name="seatInputMode"
        value="selectedSeat"
        checked={inputMode === 'selectedSeat'}
        onChange={() => handleInputModeChange('selectedSeat')}
      />
      블록 지정
    </Label>
    <Input
      type="text"
      placeholder="좌석 정보"
      value={transformSeatInfoInString(selectedSeat)}
      disabled={inputMode !== 'selectedSeat'}
    />
  </RadioContainer>
</FormGroup>
       
<FormGroup>
  <RadioContainer>
    <Label>
      <input
        type="radio"
        name="seatInputMode"
        value="manual"
        checked={inputMode === 'manual'}
        onChange={() => handleInputModeChange('manual')}
      />
      직접 입력
    </Label>
    <Input
      type="text"
      placeholder="ex) C1, C2 "
      value={seatText}
      onChange={(e) => setSeatText(e.target.value)}
      disabled={inputMode !== 'manual'}
    />
  </RadioContainer>
</FormGroup>
</div>

{/* 환불계좌 정보 섹션 */}
<RefundAccountSection>
  <RefundAccountTitle>
    환불계좌 정보
    {hasExistingBankInfo && <RegisteredBadge>등록됨</RegisteredBadge>}
  </RefundAccountTitle>
  <RefundAccountNotice>
    예매 취소 시 환불받으실 계좌 정보를 입력해주세요.
    {hasExistingBankInfo && ' (기존 등록된 계좌 정보가 표시됩니다. 수정 가능합니다.)'}
  </RefundAccountNotice>

  <RefundFieldGroup>
    <RefundLabel>은행명 <RequiredMark>*</RequiredMark></RefundLabel>
    <RefundSelect
      name="bank_name"
      value={refundBankInfo.bank_name}
      onChange={handleRefundBankChange}
      required
    >
      <option value="">은행을 선택하세요</option>
      {bankOptions.map((bank) => (
        <option key={bank} value={bank}>{bank}</option>
      ))}
    </RefundSelect>
  </RefundFieldGroup>

  <RefundFieldGroup>
    <RefundLabel>계좌번호 <RequiredMark>*</RequiredMark></RefundLabel>
    <RefundInput
      type="text"
      name="account_number"
      value={refundBankInfo.account_number}
      onChange={handleRefundBankChange}
      placeholder="계좌번호 입력 ('-' 없이)"
      required
    />
  </RefundFieldGroup>

  <RefundFieldGroup>
    <RefundLabel>예금주명 <RequiredMark>*</RequiredMark></RefundLabel>
    <RefundInput
      type="text"
      name="account_holder_name"
      value={refundBankInfo.account_holder_name}
      onChange={handleRefundBankChange}
      placeholder="예금주명 입력"
      required
    />
  </RefundFieldGroup>
</RefundAccountSection>

<div style={{ display:'flex',alignItems:'center',flexDirection: 'column'}}>
     <ButtonGroup>
            <Button type="submit">예매 주문</Button>
            <Button type="button" onClick={onClose}>취소</Button>
          </ButtonGroup>
  </div>
     
                        {/* 잔여좌석 확인 섹션 추가 */}
          <FormGroup>
            <SeatCheckSection>
              <SeatCheckNotice>
                대행예매 전에 {movieInfo.cinemaBrand} 공식 사이트에서<br/>
                실시간 잔여좌석을 확인하실 수 있습니다.
              </SeatCheckNotice>
              <ReferenceButton 
                type="button"
                onClick={() => openCinemaBookingSite(movieInfo.cinemaBrand)}
              >
                📍 {movieInfo.cinemaBrand} 공식 예매사이트 (잔여좌석 확인용)
              </ReferenceButton>
            </SeatCheckSection>
          </FormGroup>
        </Form>

      </ModalContent>

    </ModalOverlay>
  );
};

export default OrderFormModal;

// 스타일 컴포넌트들을 더 작게 수정
const SeatCheckSection = styled.div`
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 8px;
  margin: 8px 0;
`;

const SeatCheckNotice = styled.div`
  font-size: 0.7rem;
  color: #495057;
  line-height: 1.3;
  margin-bottom: 6px;
  padding: 4px 6px;
  background-color: #e9ecef;
  border-radius: 3px;
  border-left: 2px solid #17a2b8;
`;

const ReferenceButton = styled.button`
  background: #17a2b8;
  color: white;
  border: none;
  padding: 6px 10px;
  cursor: pointer;
  font-size: 0.7rem;
  border-radius: 4px;
  width: 100%;
  transition: background 0.3s;
  position: relative;
  
  &:hover {
    background: #138496;
  }
  
  &:before {
    content: '';
    position: absolute;
    top: -1px;
    left: -1px;
    right: -1px;
    bottom: -1px;
    border: 1px dashed #17a2b8;
    border-radius: 5px;
    opacity: 0.6;
  }
`;

// 스타일 컴포넌트들 정의

const ModalOverlay = styled.div`
  position: fixed;
  top: 120px;
  left: 0;
  width: 100%;
  height: calc(100% - 120px);
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 30px 20px;
  overflow-y: auto;
  box-sizing: border-box;
  z-index: 999;

  @media (max-width: 768px) {
    top: 80px;
    height: calc(100% - 80px);
    padding: 20px 15px;
  }
`;

const ModalContent = styled.div`
  background: white;
  padding: 1.5rem;
  border-radius: 12px;
  width: 500px;
  max-width: 90%;
  max-height: calc(100vh - 220px);
  overflow-y: auto;
  overflow-x: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);

  /* 스크롤바 스타일링 */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 0 12px 12px 0;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a1a1a1;
  }

  @media (max-width: 768px) {
    padding: 1rem;
    max-height: calc(100vh - 160px);
    border-radius: 10px;

    &::-webkit-scrollbar-track {
      border-radius: 0 10px 10px 0;
    }
  }
`;

const FormTitle = styled.h2`
  margin-bottom: 1rem;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

const FormGroup = styled.div`
  margin-bottom: 1rem;
`;

const Label = styled.label`
  margin-bottom: 0.5rem;
  margin-right: 10px;
  font-weight: bold;
`;

const Select = styled.select`
  padding: 0.5rem;
  border-radius: 4px;
  border: 1px solid #ccc;
`;

const Input = styled.input`
  padding: 0.5rem;
  border-radius: 4px;
  border: 1px solid #ccc;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const Button = styled.button`
  background: #007bff;
  color: white;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 1rem;
  border-radius: 5px;
  transition: background 0.3s;
  &:hover {
    background: #0056b3;
  }
  &:not(:last-child) {
    margin-right: 10px;
  }
`;

const ScreenContainer = styled.div`
  margin: 1rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Screen = styled.div`
  background: linear-gradient(to bottom, #ccc, #999);
  padding: 0.5rem;
  margin-bottom: 1rem;
  width: 100%;
  max-width: 400px;
  text-align: center;
  font-weight: bold;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const SeatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 5px;
  width: 90%;
  max-width: 300px;
`;

const SeatBox = styled.div`
  background: ${props => (props.selected ? '#007bff' : '#e0e0e0')};
  padding: 10px;
  text-align: center;
  font-size: 12px;
  border-radius: 4px;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  transition: background 0.3s, transform 0.3s;
  box-shadow: ${props => (props.selected ? '0 4px 6px rgba(0, 123, 255, 0.2)' : '0 4px 6px rgba(0, 0, 0, 0.1)')};
  &:hover {
    background: ${props => (props.selected ? '#0056b3' : props.disabled ? '#e0e0e0' : '#c1c1c1')};
    transform: ${props => (props.disabled ? 'none' : 'scale(1.05)')};
  }
`;
const RadioContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  input[type="radio"] {
    margin-right: 0.5rem;
  }

  input[type="text"] {
    flex: 1;
  }
`;

// 환불계좌 관련 스타일 컴포넌트
const RefundAccountSection = styled.div`
  background-color: #fff8e1;
  border: 1px solid #ffc107;
  border-radius: 8px;
  padding: 16px;
  margin: 16px 0;
`;

const RefundAccountTitle = styled.h3`
  font-size: 1rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const RegisteredBadge = styled.span`
  background-color: #4caf50;
  color: white;
  font-size: 0.7rem;
  padding: 2px 8px;
  border-radius: 10px;
  font-weight: normal;
`;

const RefundAccountNotice = styled.p`
  font-size: 0.75rem;
  color: #666;
  margin-bottom: 12px;
  line-height: 1.4;
`;

const RefundFieldGroup = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  gap: 10px;

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
`;

const RefundLabel = styled.label`
  font-size: 0.85rem;
  font-weight: 500;
  color: #333;
  min-width: 80px;

  @media (max-width: 480px) {
    min-width: auto;
  }
`;

const RequiredMark = styled.span`
  color: #f44336;
`;

const RefundSelect = styled.select`
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.85rem;
  background-color: white;

  &:focus {
    outline: none;
    border-color: #ffc107;
  }

  @media (max-width: 480px) {
    width: 100%;
  }
`;

const RefundInput = styled.input`
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.85rem;

  &:focus {
    outline: none;
    border-color: #ffc107;
  }

  &::placeholder {
    color: #aaa;
  }

  @media (max-width: 480px) {
    width: 100%;
  }
`;
  